const STORAGE_KEY = "fleet-accent-hue";
const DEFAULT_HUE = 155;

// OKLCH hue (0-360) for each preset. The whole palette is hue-locked, so one
// number recolors the entire UI — see --theme-hue in index.css.
export const ACCENT_PRESETS = [
  { name: "Emerald", hue: 155 },
  { name: "Teal", hue: 195 },
  { name: "Blue", hue: 255 },
  { name: "Violet", hue: 295 },
  { name: "Rose", hue: 10 },
  { name: "Amber", hue: 75 },
] as const;

export function readAccentHue(): number {
  const stored = Number(localStorage.getItem(STORAGE_KEY));
  return Number.isFinite(stored) && stored > 0 ? stored : DEFAULT_HUE;
}

export function applyAccentHue(hue: number) {
  localStorage.setItem(STORAGE_KEY, String(hue));
  document.documentElement.style.setProperty("--theme-hue", String(hue));
}
